import script from "./SummaryContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./SummaryContent.vue?vue&type=script&setup=true&lang=ts"

import "./SummaryContent.vue?vue&type=style&index=0&id=f5c27c6c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5c27c6c"]])

export default __exports__